"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Dialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));
var _WarningRounded = _interopRequireDefault(require("@material-ui/icons/WarningRounded"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _styles = require("@material-ui/core/styles");
var _Button = require("../button/Button");
var _utils = require("../utils");
var _styles2 = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CustomTooltip = (0, _styles.withStyles)(theme => ({
  tooltip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    width: 355,
    minHeight: 48,
    marginLeft: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: 14
  }
}))(_Tooltip.default);
const Dialog = _ref => {
  let {
    title,
    children,
    secondaryButton,
    primaryButton,
    size,
    alert,
    label,
    tooltipContent,
    tooltip,
    open,
    handleClose,
    handleConfirm,
    confirmWithoutCheck,
    isDisabled,
    alertMessage,
    stepper,
    handleCheck,
    PaperProps
  } = _ref;
  const classes = (0, _styles2.useStyles)();
  const alertClasses = (0, _styles2.alertStyles)();
  const [isChecked, setIsChecked] = (0, _react.useState)(false);
  const [activeStep, setActiveStep] = (0, _react.useState)(0);
  const isFinished = activeStep >= stepper.length - 1;
  const handleBack = () => setActiveStep(prevActiveStep => prevActiveStep - 1);
  const handleNext = () => setActiveStep(prevActiveStep => prevActiveStep + 1);
  if (alertMessage) {
    return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
      className: `${alertClasses.root}`,
      maxWidth: "lg",
      open: open,
      onExited: () => setIsChecked(false),
      alert: alert ? 1 : 0,
      disableScrollLock: true,
      onClose: handleClose,
      PaperProps: PaperProps
    }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, title), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
      size: size,
      style: {
        width: (0, _utils.checkSizeDialog)(size)
      },
      dividers: true
    }, /*#__PURE__*/_react.default.createElement(_WarningRounded.default, {
      className: alertClasses.warning,
      style: {
        fontSize: 64
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: alertClasses.content
    }, children, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
      className: alertClasses.checkBox,
      control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        checked: isChecked,
        onChange: () => setIsChecked(!isChecked)
      }),
      label: label
    }))), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, secondaryButton && /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.secondaryButton,
      onClick: handleClose
    }, secondaryButton), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      className: alertClasses.primaryButton,
      color: "primary",
      variant: "contained",
      onClick: isChecked ? handleConfirm : confirmWithoutCheck,
      isDisabled: isDisabled,
      disabled: !isChecked || isDisabled
    }, primaryButton)));
  }
  if (alert) {
    return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
      className: `${alertClasses.root}`,
      maxWidth: "lg",
      open: open,
      onExited: () => setIsChecked(false),
      tooltip: tooltip ? 1 : 0,
      alert: alert ? 1 : 0,
      disableScrollLock: true,
      onClose: handleClose,
      PaperProps: PaperProps
    }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, title, tooltip && /*#__PURE__*/_react.default.createElement(CustomTooltip, {
      TransitionComponent: _core.Zoom,
      title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InfoOutlined.default, {
        style: {
          fontSize: 18
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: alertClasses.tooltipcontent
      }, tooltipContent)),
      placement: "right-end"
    }, /*#__PURE__*/_react.default.createElement(_InfoOutlined.default, {
      className: alertClasses.icon
    }))), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
      size: size,
      style: {
        width: (0, _utils.checkSizeDialog)(size)
      },
      dividers: true
    }, /*#__PURE__*/_react.default.createElement(_WarningRounded.default, {
      className: alertClasses.warning,
      style: {
        fontSize: 64
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: alertClasses.content
    }, children, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
      className: alertClasses.checkBox,
      control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        checked: isChecked,
        onChange: () => {
          setIsChecked(!isChecked);
          handleCheck();
        }
      }),
      label: label
    }))), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, secondaryButton && /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.secondaryButton,
      onClick: handleClose
    }, secondaryButton), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      isDisabled: isDisabled,
      disabled: !isChecked || isDisabled,
      className: alertClasses.primaryButton,
      color: "primary",
      variant: "contained",
      onClick: handleConfirm
    }, primaryButton)));
  }
  if (stepper && stepper.length > 0) {
    return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
      className: `${alertClasses.root}`,
      maxWidth: "lg",
      open: open,
      disableScrollLock: true,
      onClose: handleClose,
      PaperProps: PaperProps
    }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, title, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "aria-label": "close",
      onClick: handleClose,
      className: alertClasses.buttonClose
    }, /*#__PURE__*/_react.default.createElement(_Close.default, null))), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
      size: size,
      style: {
        width: (0, _utils.checkSizeDialog)(size)
      },
      dividers: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: alertClasses.content
    }, stepper[activeStep])), /*#__PURE__*/_react.default.createElement(_core.DialogActions, {
      style: {
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.MobileStepper, {
      variant: "dots",
      steps: stepper.length,
      position: "static",
      activeStep: activeStep,
      className: alertClasses.stepper
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: alertClasses.contentActions
    }, secondaryButton && activeStep > 0 && /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.secondaryButton,
      onClick: handleBack,
      disabled: activeStep === 0
    }, secondaryButton), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      className: alertClasses.primaryButtonStepper,
      color: "primary",
      variant: "text",
      onClick: !isFinished ? handleNext : handleClose,
      isDisabled: isDisabled
    }, !isFinished ? primaryButton : 'FECHAR'))));
  }
  return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    className: classes.root,
    maxWidth: "lg",
    open: open,
    alert: alert ? 1 : 0,
    disableScrollLock: true,
    onClose: handleClose,
    PaperProps: PaperProps
  }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, title), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    size: size,
    style: {
      width: (0, _utils.checkSizeDialog)(size)
    },
    dividers: true
  }, children), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, secondaryButton && /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.secondaryButton,
    onClick: handleClose
  }, secondaryButton), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.primaryButton,
    onClick: handleConfirm,
    isDisabled: isDisabled,
    disabled: isDisabled,
    autoFocus: true
  }, primaryButton)));
};
exports.Dialog = Dialog;
Dialog.propTypes = {
  /**
   * Se 'True', o dialog é aberto
   */
  open: _propTypes.default.bool,
  /**
   * Escolhe o texto to título
   */
  title: _propTypes.default.string.isRequired,
  /**
   * Texto do conteúdo
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Texto do botão primário
   */
  primaryButton: _propTypes.default.string.isRequired,
  /**
   * Seleciona o tamanho do dialog
   */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full']),
  /**
   * Se 'True', o component tem as características de alert
   */
  alert: _propTypes.default.bool,
  /**
   * Se 'True', habilita o tooltip
   */
  tooltip: _propTypes.default.bool,
  /**
   * Texto do botão secundário
   */
  secondaryButton: _propTypes.default.string,
  /**
   * Texto do checkbox
   */
  label: _propTypes.default.string,
  /**
   * Funcao a ser executada ao clicar no botao secundario
   */
  handleClose: _propTypes.default.func,
  /**
  /**
   * Funcao a ser executada ao clicar no checkbox
   */
  handleCheck: _propTypes.default.func,
  /**
   * Funcao a ser executada ao clicar no botao primario
   */
  handleConfirm: _propTypes.default.func.isRequired,
  /**
   * Funcao a ser executada ao clicar no botao primario sem o checkbox marcado (uso apenas no alertMessage)
   */
  confirmWithoutCheck: _propTypes.default.func.isRequired,
  /**
   * Texto presente no tooltip
   */
  tooltipContent: _propTypes.default.string,
  /**
   * Se 'true' o botão primário fica desabilitado
   */
  isDisabled: _propTypes.default.bool,
  /**
   * Se 'True', o component tem as características de alert porém pode ser clicado sem o checkbox
   */
  alertMessage: _propTypes.default.bool,
  /**
   * Se 'True', o component tem as características de stepper porém pode ser clicado sem o checkbox
   */
  stepper: _propTypes.default.arrayOf(_propTypes.default.node),
  /**
   * Objeto que define propriedades customizadas do elemento Paper.
   */
  PaperProps: _propTypes.default.shape()
};
Dialog.defaultProps = {
  open: false,
  secondaryButton: '',
  size: 'md',
  alert: false,
  alertMessage: false,
  label: 'aceito',
  handleClose: null,
  tooltipContent: 'Texto padrao do tooltip',
  tooltip: false,
  isDisabled: false,
  handleCheck: null,
  stepper: [],
  PaperProps: {}
};
var _default = exports.default = Dialog;